import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import * as globals from "app/resources/globals";

interface Props {
    value: models.EntregaZEItem;
}

const VerButton = kea.defaultProps(kea.Button, { children: "Ver", style: "info", iconClass: fa("eye") });

export class EntregaItemComp extends React.PureComponent<Props> {
    onVerEntrega = () => {
        history.go("./" + this.props.value.IdRegistro);
    }

    render() {
        const x = this.props.value;
        return (
            <kea.Panel title="Entrega realizada"
                style="success"
                buttons={[
                    <VerButton onClick={this.onVerEntrega} />
                ]}
            >
                <label>Fecha: </label>{" "}{kea.formatDate(x.Fecha, true)}
                <br />
                <label>Guias entregadas: </label>{" "}{x.CantGuiasEntregadas}
                <br />
                <label>Guias rechazadas: </label>{" "}{x.CantGuiasRechazadas}
                <br />
                <label>Total a pagar: </label>{" "}{kea.formatCurrency(x.TotalPagar)}
                <br />
            </kea.Panel>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajeappZE/entregas/item.tsx